module.exports = __webpack_public_path__ + "static/img/app_share_ship_merchant-app-logo.e8fb884.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/app_share_ship_merchant-app-logo.png
// module id = OAHG
// module chunks = 1